import React from 'react';
import { Link } from 'react-router-dom';
import styles from './marketing.module.css';
import { SEO } from '../components/SEO.jsx';

export function MarketingArticle({
  title,
  description,
  kicker,
  heroImage,
  heroAlt,
  primaryAction,
  secondaryAction,
  sections,
  path,
}) {
  return (
    <main className={styles.page}>
      <SEO title={title} description={description} path={path || '/overview'} type="article" />

      <section className={styles.hero}>
        <img className={styles.heroImage} src={heroImage} alt={heroAlt} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <p className={styles.kicker}>{kicker}</p>
          <h1 className={styles.heroTitle}>{title}</h1>
          <p className={styles.heroText}>{description}</p>
          <div className={styles.actions}>
            {primaryAction && (
              <Link className={styles.primaryAction} to={primaryAction.to}>
                {primaryAction.label}
              </Link>
            )}
            {secondaryAction && (
              <Link className={styles.secondaryAction} to={secondaryAction.to}>
                {secondaryAction.label}
              </Link>
            )}
          </div>
        </div>
      </section>

      {sections.map((section, index) => {
        const sectionClass = index % 2 === 0 ? styles.section : styles.sectionAlt;
        const body = (
          <div className={styles.article}>
            <span className={styles.tag}>{section.tag}</span>
            <h2>{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.items && (
              <ul className={styles.list}>
                {section.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        );

        if (!section.image) {
          return (
            <section className={sectionClass} key={section.title}>
              <div className={styles.sectionInner}>{body}</div>
            </section>
          );
        }

        return (
          <section className={sectionClass} key={section.title}>
            <div className={styles.split}>
              <div className={styles.articleImage}>
                <img src={section.image} alt={section.imageAlt} />
              </div>
              {body}
            </div>
          </section>
        );
      })}
    </main>
  );
}
